/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ClearableSearchField } from "components/SearchField/SearchField";
import { Visibility } from "@mui/icons-material";
import {
  AppBar,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import breakpoints from "assets/theme/base/breakpoints";
import Auto from "components/AutoComplete/AutoComplete";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import MuiPhoneNumber from "material-ui-phone-number";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  addEmployeeData,
  deleteSelectedDocument,
  getDocument,
  getEmployeeByID,
  getEmployeeNameList,
  getParameterListName,
  getWarehouseList,
  updateEmployeeData,
} from "utils/api";
import { appConstants } from "utils/appConstants";
import {
  blank,
  generateDataList,
  getScreenRight,
  handleStreetAddress,
  showResMsg,
  validateEmailField,
  validateField,
  validatePhoneNumberField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let fetchedEmployee;
function EditEmployee({ ...props }) {
  const { id } = useParams();
  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [table, setTable] = useState("personalInformation");
  const [showDocuments, setshowDocumentsTable] = useState(false);
  const [showEmployeeInfo, setshowEmployeeInfoTable] = useState(false);
  const [showPersonalInfo, setShowPersonalInfoTable] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState("");
  const [screenName, setScreenName] = useState("Edit Employee");

  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [disableColor, setDisableColor] = useState(false);
  const [file, setFile] = useState();
  const [actualFile, setActualFile] = useState();
  const [fileName, setFileName] = useState("");
  const [imgSupportingText, setImgSupportingText] = useState("");
  const [fileIdCard, setFileIdCard] = useState();
  const [actualFile1, setActualFileIdCard] = useState();
  const [fileName1, setFileNameIdCard] = useState("");
  const [imgSupportingTextIdCard, setImgSupportingTextIdCard] = useState("");

  const [showViewImageFlag, setShowViewImageModalFlag] = useState(false);
  const [showProfileModalFlag, setShowProfileModalFlag] = useState(false);
  const [showProfileModalFlagIdcard, setShowProfileModalFlagIdcard] =
    useState(false);
  const [hideEyeBtn, setHideEyeBtn] = useState(false);
  const [hideEyeId, sethideEyeId] = useState(false);
  const [hidefield, setHidefield] = useState(false);
  const [showfield, setshowfield] = useState(false);
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [warehouse, setWarehouse] = useState("");
  const [employee, setEmployee] = useState("");
  const [viewImage, setViewImage] = useState("");
  const [memberNumberErr, setMemberNumberErr] = useState(false);
  const [taxFileNumberErr, setTaxFileNumberErr] = useState(false);
  const [employeeWarehouseLocationErr, setEmployeeWarehouseLocationErr] =
    useState(false);
  const [mobileAppUserPasswordErr, setMobileAppUserPasswordErr] =
    useState(false);
  const [mobileAppUserNameErr, setMobileAppUserNameErr] = useState(false);
  const [hideAddNewBtn, setHideAddNewBtn] = useState(false);
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastNameErr, setLastNameErr] = useState(false);
  const [genderErr, setGenderErr] = useState(false);
  const [birthDateErr, setbirthDateErr] = useState(false);
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipCodeErr, setZipCodeErr] = useState(false);
  const [emailAddressErr, setEmailAddressErr] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState("");
  const [phoneNumberErr, setPhoneNumberErr] = useState(false);
  const [pNumberErrMsg, setpNumberErrMsg] = useState("");
  const [joiningDateErr, setJoiningDateErr] = useState(false);
  const [relievingDateErr, setRelievingDate] = useState(false);
  const [employeeTypeErr, setEmployeeTypeErr] = useState(false);
  const [employeeCodeErr, setEmployeeCodeErr] = useState(false);
  const [departmentErr, setDepartmentErr] = useState(false);
  const [designationErr, setDesignationErr] = useState(false);
  const [attendanceErr, setAttendanceErr] = useState(false);
  const [idCardIssueDateErr, setIdCardIssueDateErr] = useState(false);
  const [recruitmentErr, setRecruitmentErr] = useState(false);
  const [experienceMonthsErr, setExperienceMonthsErr] = useState(false);
  const [experienceMonthsTitleErr, setExperienceMonthsTitleErr] = useState("");
  const [experienceYearsErr, setExperienceYearsErr] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDateJoin, setSelectedDateJoin] = useState("");
  const [selectedDateReleiving, setSelectedDateReleiving] = useState("");
  const [selectedDateJoinIssueDate, setSelectedDateIssueDate] = useState("");
  const [deleteHeading, setDeleteHeading] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [empID, setEmpID] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let countryData = useSelector(
    (state) => state.countryState.countryStateMenu.country
  );
  let stateData = useSelector(
    (state) => state.countryState.countryStateMenu.state
  );

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const [values, setValues] = React.useState({
    _id: [],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      .businessUserID,
    firstName: "",
    lastName: "",
    gender: "",
    birthDate: "",
    streetAddress: "",
    city: "",
    zipCode: "",
    stateId: "",
    countryId: "",
    emailAddress: "",
    phoneNumber: "+61",
    countryCode: "+61",
    profileFileName: "",
    employeeStatus: "Active",
    emergencyContactName: "",
    emergencyContactNumber: "+61",
    relationshipWithEmployee: "",
    notes: "",
    employeeType: "",
    employeeCode: "",
    joiningDate: "",
    releivingDate: "",
    department: "",
    designation: "",
    circle: "",
    location: "",
    iDCardIssueDate: "",
    iDCardFileName: "",
    attendanceType: "",
    recruitmentType: "",
    experienceYears: "",
    experienceMonths: "",
    reportingManagerEmployeeID: "",
    taxFileNumber: "",
    memberNumber: "",
    superGuaranteeFundProduct: "",
    mobileAppAccess: "None",
    employeeWarehouseLocation: "",
    mobileAppUserName: "",
    mobileAppUserPassword: "",
    searchParameter: "",
    searchParameterList: [
      "employeeType",
      "firstName",
      "lastName",
      "departmentName",
      "designation",
      "employeeStatus",
    ],
  });

  let mandateFlag = false;
  values.id = empID;
  const [values1, setValues1] = React.useState({
    documentName: "",
    documentType: "",
    documentFileName: "",
    page: appConstants.page,
    limit: appConstants.limit,
    sortingType: "",
    sortingField: "",
    filterValues: "",
    searchParameterList: ["documentType", "documentName", "uploadedDate"],
  });

  function parseDateString(dateString) {
    const parts = dateString.split(/[-T:.Z]/); // Split the string into parts
    const [year, month, day, hours, minutes, seconds] = parts.map(Number);
    return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
  }

  useEffect(() => {
    (async () => {
      getRight();
      stateListRef.current = stateData;
      countryListRef.current = countryData;
      setCountry(await generateDataList(countryData, "_id", "countryName"));
      setState(await generateDataList(stateData, "_id", "stateName"));
      if (id !== undefined) {
        values.id = id;
        getEmployeeByID(
          values,
          (data) => {
            if (data.Result_Output.length > 0) {
              fetchedEmployee = data.Result_Output[0];
              setHidefield(true);
              setshowfield(false);
              if (fetchedEmployee.birthDate) {
                fetchedEmployee.birthDate = parseDateString(
                  fetchedEmployee.birthDate
                );
                handleDateChange(fetchedEmployee.birthDate);
              }
              if (fetchedEmployee.joiningDate) {
                fetchedEmployee.joiningDate = parseDateString(
                  fetchedEmployee.joiningDate
                );
                handleDateChangeJoin(fetchedEmployee.joiningDate);
              }

              if (fetchedEmployee.iDCardIssueDate) {
                fetchedEmployee.iDCardIssueDate = parseDateString(
                  fetchedEmployee.iDCardIssueDate
                );
                handleDateChangeIssueDate(fetchedEmployee.iDCardIssueDate);
              }

              if (fetchedEmployee.releivingDate) {
                fetchedEmployee.releivingDate = parseDateString(
                  fetchedEmployee.releivingDate
                );
                handleDateChangeReleiving(fetchedEmployee.releivingDate);
              }
              values.profileFileName = fetchedEmployee.profileFileName;
              if (
                values.profileFileName !== undefined &&
                values.profileFileName !== ""
              ) {
                setHideEyeBtn(true);
                setFile(
                  appConstants.baseURL +
                    "employee/viewFile?fileName=" +
                    values.profileFileName
                );
              }
              values.iDCardFileName = fetchedEmployee.iDCardFileName;
              if (
                values.iDCardFileName !== undefined &&
                values.iDCardFileName !== ""
              ) {
                sethideEyeId(true);
                setFileIdCard(
                  appConstants.baseURL +
                    "employee/viewFile?fileName=" +
                    values.iDCardFileName
                );
              } else {
                values.iDCardFileName = "";
              }

              setValues(fetchedEmployee);
            }
          },
          dispatch
        );
      }
    })();
  }, []);
  async function getRight() {
    let right = await getScreenRight("Employees");
    if (right === "Full Access") setDisableColor(false);
    else setDisableColor(true);
  }
  const handleChange = (name) => (event) => {
    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchDocument();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    values1.sortingType = value;
    values1.sortingField = type;
  };
  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      if (toggleCleared) setSelectedRows([]);
      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records?");
      if (selectedRows) {
        values._id = [];
        for (let element of selectedRows) {
          values._id.push(element._id);
        }
      }
    };
    return (
      <MDButton onClick={handleDeleteMultiple} color="error">
        Delete
      </MDButton>
    );
  }, [selectedRows, toggleCleared]);
  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) setTitle(" ");
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);
  useEffect(() => {
    Promise.all([
      fetchDepartment(),
      fetchEmployeeName(),
      fetchWarehouseLocation(),
    ]);
    if (id !== undefined) setEmpID(id);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === "documents") {
      setTable("documents");
    }
    if (table === "personalInformation") {
      setshowEmployeeInfoTable(false);
      setShowPersonalInfoTable(true);
      setTabValue(0);
      setshowDocumentsTable(false);
    } else if (table === "employeeInformation") {
      setshowEmployeeInfoTable(true);
      setTabValue(1);
      setShowPersonalInfoTable(false);
      setshowDocumentsTable(false);
    } else if (table === "documents") {
      setshowEmployeeInfoTable(false);
      setShowPersonalInfoTable(false);
      setshowDocumentsTable(true);
      setTabValue(2);
      fetchDocument();
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);

  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone;
    values.countryCode = "+" + country.dialCode;
  };
  const setPhoneValues1 = (phone, country) => {
    values.onlyPhoneNumber1 = phone.slice(country.dialCode.length);
    values.emergencyContactNumber = phone.slice(country.dialCode.length);
    values.emergencyContactNumber = phone;
    values.countryCode = "+" + country.dialCode;
  };

  const clearErrorStates = () => {
    setEmployeeTypeErr(false);
    setMobileAppUserNameErr(false);
    setMobileAppUserPasswordErr(false);
    setEmployeeWarehouseLocationErr(false);
    setEmployeeWarehouseLocationErr(false);
    setJoiningDateErr(false);
    setDepartmentErr(false);
    setDesignationErr(false);
    setAttendanceErr(false);
    setPhoneNumberErr(false);
    setemailTitleErr(false);
    setStreetAddressErr(false);
    setbirthDateErr(false);
    setGenderErr(false);
    setLastNameErr(false);
    setFirstNameErr(false);
  };

  const updateEmployee = () => {
    mandateFlag = false;
    clearErrorStates();
    mandateFlag =
      validateField(values.employeeType, setEmployeeTypeErr) || mandateFlag;
    if (values.mobileAppAccess === "None") {
      setMobileAppUserNameErr(false);
      setMobileAppUserPasswordErr(false);
      setEmployeeWarehouseLocationErr(false);
    } else if (values.mobileAppAccess === "Driver") {
      mandateFlag =
        validateField(values.mobileAppUserName, setMobileAppUserNameErr) ||
        mandateFlag;
      mandateFlag =
        validateField(
          values.mobileAppUserPassword,
          setMobileAppUserPasswordErr
        ) || mandateFlag;
      setEmployeeWarehouseLocationErr(false);
    } else if (values.mobileAppAccess === "Warehouse") {
      mandateFlag =
        validateField(
          values.employeeWarehouseLocation,
          setEmployeeWarehouseLocationErr
        ) || mandateFlag;
    }
    mandateFlag =
      validateField(values.joiningDate, setJoiningDateErr) || mandateFlag;
    mandateFlag =
      validateField(values.department, setDepartmentErr) || mandateFlag;
    mandateFlag =
      validateField(values.designation, setDesignationErr) || mandateFlag;
    mandateFlag =
      validateField(values.attendanceType, setAttendanceErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    values.id = empID;
    const arrayOfObjects = Object.entries(values).map(([key, value]) => ({
      key,
      value,
    }));
    const formData = new FormData();
    arrayOfObjects.map((val) => {
      if (val.value !== "" && val.value !== undefined)
        formData.append(val.key, val.value);
    });
    if (actualFile && fileName !== undefined && actualFile && fileName !== "") {
      formData.append("file", actualFile);
      formData.append("fileName", fileName);
    }

    if (
      actualFile1 &&
      fileName1 !== undefined &&
      actualFile1 &&
      fileName1 !== ""
    ) {
      formData.append("file1", actualFile1);
      formData.append("fileName1", fileName1);
    }

    if (empID !== "") {
      if (
        values.mobileAppAccess === "None" ||
        values.mobileAppAccess === "Driver"
      ) {
        values.fetchWarehouseLocation = undefined;
      }
      updateEmployeeData(
        formData,
        (data) => {
          showResMsg(
            data.Result_Status ? genericMessage.updated : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            "/employees"
          );
        },
        dispatch
      );
    } else {
      values._id = undefined;
      addEmployeeData(
        formData,
        (data) => {
          showResMsg(
            data.Result_Status ? genericMessage.added : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            "/employees"
          );
          if (data.Result_Status) {
            setEmpID(data.Result_Output._id);
          }
        },
        dispatch
      );
    }
  };
  const saveFile = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
    setActualFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
    setImgSupportingText("none");
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setShowProfileModalFlag(false);
        setHideEyeBtn(true);
      };
      reader.readAsDataURL(file);
    } else {
      setHideEyeBtn(false);
    }
  };
  const saveFileIdCard = (e) => {
    setFileIdCard(URL.createObjectURL(e.target.files[0]));
    setActualFileIdCard(e.target.files[0]);
    setFileNameIdCard(e.target.files[0].name);
    setImgSupportingTextIdCard("none");

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setShowProfileModalFlagIdcard(false);
        sethideEyeId(true);
      };
      reader.readAsDataURL(file);
    } else {
      sethideEyeId(false);
    }
  };

  let fetchDepartment = async () => {
    getParameterListName(async (data) => {
      if (data.Result_Output.length > 0) {
        for (let parameter of data.Result_Output) {
          if (parameter.parameterCode === "DE") {
            parameter.parameterList.sort(
              (a, b) => a.parameterListSequence - b.parameterListSequence
            );
            setDepartment(
              await generateDataList(
                parameter.parameterList,
                "parameterListName",
                "parameterListName"
              )
            );
          } else if (parameter.parameterCode === "DG") {
            parameter.parameterList.sort(
              (a, b) => a.parameterListSequence - b.parameterListSequence
            );
            setDesignation(
              await generateDataList(
                parameter.parameterList,
                "parameterListName",
                "parameterListName"
              )
            );
          }
        }
      }
    });
  };
  let fetchEmployeeName = async () => {
    values.id = id;
    getEmployeeNameList(
      {
        _id: values.id,
        businessUserID: values.businessUserID,
        designation: values.designation,
      },
      (data) => {
        if (data.Result_Output.length > 0)
          values.reportingManagerEmployeeID = data.Result_Output[0]._id;
        setEmployee(data.Result_Output);
      },
      dispatch
    );
  };

  let EmployeeList =
    employee.length > 0 &&
    employee.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.firstName} {item.lastName}
        </MenuItem>
      );
    }, this);
  let fetchWarehouseLocation = async () => {
    getWarehouseList(
      values,
      async (data) => {
        if (data.Result_Output.length > 0)
          values.employeeWarehouseLocation = data.Result_Output[0]._id;
        setWarehouse(
          await generateDataList(data.Result_Output, "_id", "warehouseName")
        );
      },
      dispatch
    );
  };

  useEffect(() => {
    if (values.mobileAppAccess === "None") {
      setHidefield(true);
      setshowfield(false);
      setValues({
        ...values,
        employeeWarehouseLocation: "",
        mobileAppUserName: "",
        mobileAppUserPassword: "",
      });
    } else if (values.mobileAppAccess === "Driver") {
      setshowfield(true);
      setHidefield(false);
      setValues({ ...values, employeeWarehouseLocation: "" });
    } else if (values.mobileAppAccess === "Warehouse") {
      setshowfield(true);
      setHidefield(false);
      setValues({ ...values });
    }
  }, [values.mobileAppAccess]);

  const nextTabs = () => {
    mandateFlag = false;
    clearErrorStates();
    mandateFlag =
      validateField(values.firstName, setFirstNameErr) || mandateFlag;
    mandateFlag = validateField(values.lastName, setLastNameErr) || mandateFlag;
    mandateFlag = validateField(values.gender, setGenderErr) || mandateFlag;
    mandateFlag =
      validateField(values.birthDate, setbirthDateErr) || mandateFlag;
    mandateFlag =
      validateField(values.streetAddress, setStreetAddressErr) || mandateFlag;
    mandateFlag =
      validateEmailField(
        values.emailAddress,
        setEmailAddressErr,
        setemailTitleErr
      ) || mandateFlag;
    mandateFlag =
      validatePhoneNumberField(
        values.phoneNumber,
        setPhoneNumberErr,
        setpNumberErrMsg
      ) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const arrayOfObjects = Object.entries(values).map(([key, value]) => ({
      key,
      value,
    }));
    const formData = new FormData();
    arrayOfObjects.map((val) => {
      if (val.value !== "" && val.value !== undefined)
        formData.append(val.key, val.value);
    });
    formData.append("file", actualFile);
    formData.append("fileName", fileName);
    // if (empID === "") {
    //   values._id= undefined
    //   addEmployeeData(formData, (data) => {
    //     showResMsg(data.Result_Status ? genericMessage.added : data.Result_Message, 1000, data.Result_Status);
    //     if (data.Result_Status) {
    //       setshowEmployeeInfoTable(true);
    //       setTabValue(1)
    //       setTable("employeeInformation")
    //       setShowPersonalInfoTable(false);
    //       setshowDocumentsTable(false)
    //       setHideAddNewBtn(false)
    //       setEmpID(data.Result_Output._id)
    //     }
    //   }, dispatch)
    // } else {
    setshowEmployeeInfoTable(true);
    setTabValue(1);
    setTable("employeeInformation");
    setShowPersonalInfoTable(false);
    setshowDocumentsTable(false);
    setHideAddNewBtn(false);
    // }
  };
  const handleDateChange = (date) => {
    values.birthDate = date;
    setSelectedDate(date);
  };

  const handleDateChangeJoin = (date) => {
    values.joiningDate = date;
    setSelectedDateJoin(date);
  };

  const handleDateChangeIssueDate = (date) => {
    values.iDCardIssueDate = date;
    setSelectedDateIssueDate(date);
  };

  const handleDateChangeReleiving = (date) => {
    values.releivingDate = date;
    setSelectedDateReleiving(date);
  };

  const viewProfilePic = () => {
    setShowProfileModalFlag(!showProfileModalFlag);
  };
  const handleCancelProfilePic = (name) => (event) => {
    setShowProfileModalFlag(false);
  };

  const viewFileIdCard = () => {
    setShowProfileModalFlagIdcard(!showProfileModalFlagIdcard);
  };
  const handleCancelIdCard = (name) => (event) => {
    setShowProfileModalFlagIdcard(false);
  };

  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        city: "",
        streetAddress: "",
        countryId: "",
        zipCode: "",
        stateId: "",
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        streetAddress: e.target.value,
      }));
    }
  };

  const personalInfo = (
    <>
      {showPersonalInfo && (
        <MDBox mt={6} mb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={6}>
              <Card sx={{ boxShadow: "none" }}>
                <MDBox pt={4} pb={3} px={3}>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="First Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z ]+$",
                              maxLength: 30,
                            }}
                            value={values.firstName}
                            onChange={handleChange("firstName")}
                          />
                          {firstNameErr ? (
                            <span style={errMsg}>
                              First Name can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Last Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z ]+$",
                              maxLength: 30,
                            }}
                            value={values.lastName}
                            onChange={handleChange("lastName")}
                          />
                          {lastNameErr ? (
                            <span style={errMsg}>Last Name can't be blank</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Gender
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ height: "44.13px" }}
                            label="Gender"
                            onChange={handleChange("gender")}
                            value={values.gender}
                          >
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                          </Select>
                        </FormControl>
                        {genderErr ? (
                          <span style={errMsg}>Gender can't be blank</span>
                        ) : (
                          ""
                        )}
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <PickDate
                            selected={selectedDate}
                            onChange={handleDateChange}
                            label="Birth Date"
                            maxDate={new Date()}
                          />
                          {birthDateErr ? (
                            <span style={errMsg}>
                              Birth Date can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <Auto
                            onChange={handleStreetOnChange}
                            onPlaceSelected={(place, e) =>
                              handleStreetAddress(
                                place,
                                e,
                                (data) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    zipCode: data.zipCode,
                                    city: data.city,
                                    countryId: data.countryId,
                                    stateId: data.stateId,
                                    streetAddress: data.streetAddress,
                                  }));
                                },
                                stateListRef,
                                countryListRef
                              )
                            }
                            value={values.streetAddress}
                            standard="false"
                          />
                          {streetAddressErr ? (
                            <span style={errMsg}>
                              Street Address can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="City"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                            disabled
                            value={values.city}
                            onChange={handleChange("city")}
                          />
                          {cityErr ? (
                            <span style={errMsg}>City can't be blank</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Zip Code"
                            variant="outlined"
                            fullWidth
                            disabled
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 4,
                            }}
                            value={values.zipCode}
                            onChange={handleChange("zipCode")}
                          />
                          {zipCodeErr !== "" ? (
                            <span style={errMsg}>{zipCodeErr}</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Country
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ height: "44.13px" }}
                            label="Country"
                            disabled
                            onChange={handleChange("countryId")}
                            value={values.countryId}
                          >
                            {country}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            State
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ height: "44.13px" }}
                            label="State"
                            disabled
                            onChange={handleChange("stateId")}
                            value={values.stateId}
                          >
                            {state}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Email Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              maxLength: 50,
                            }}
                            value={values.emailAddress}
                            onChange={handleChange("emailAddress")}
                          />
                          {emailAddressErr ? (
                            <span style={errMsg}>{emailTitleErr}</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MuiPhoneNumber
                        defaultCountry={"australia"}
                        type="text"
                        label="Mobile Number"
                        variant="outlined"
                        fullWidth
                        value={values.phoneNumber}
                        onChange={(phone, country) =>
                          setPhoneValues(phone, country)
                        }
                      />
                      {phoneNumberErr ? (
                        <span style={errMsg}>{pNumberErrMsg}</span>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item xs={12} lg={3} sx={{ display: "flex" }}>
                      <MDBox component="form" role="form" value={fileName}>
                        <TextField
                          type="file"
                          accept="image/*"
                          name={file}
                          label="Profile Picture (Optional)"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          onChange={saveFile}
                        />
                        <p style={{ fontSize: "12px", marginBottom: "30px" }}>
                          {fileName}
                        </p>
                      </MDBox>
                      <Grid item xs={2.3}>
                        {hideEyeBtn ? (
                          <IconButton
                            style={{ marginLeft: "12px", marginTop: "-3px" }}
                          >
                            <Visibility
                              fontSize="large"
                              color="info"
                              onClick={viewProfilePic}
                            />
                          </IconButton>
                        ) : (
                          <IconButton
                            style={{ marginLeft: "12px", marginTop: "-3px" }}
                          >
                            <Visibility fontSize="large" color="grey" />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Employee Status
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ height: "44.13px" }}
                            label="Employee Status"
                            onChange={handleChange("employeeStatus")}
                            value={values.employeeStatus}
                          >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Emergency Contact Person Name (Optional)"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z ]+$",
                              maxLength: 30,
                            }}
                            value={values.emergencyContactName}
                            onChange={handleChange("emergencyContactName")}
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <MuiPhoneNumber
                            defaultCountry={"australia"}
                            type="text"
                            label="Emergency Contact Number (Optional)"
                            variant="outlined"
                            fullWidth
                            value={values.emergencyContactNumber}
                            onChange={(phone, country) =>
                              setPhoneValues1(phone, country)
                            }
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Relationship with Employee (Optional)
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ height: "44.13px" }}
                            label=" Relationship with Employee (Optional)"
                            onChange={handleChange("relationshipWithEmployee")}
                            value={values.relationshipWithEmployee}
                          >
                            <MenuItem value="">Select.. </MenuItem>
                            <MenuItem value="Family">Family</MenuItem>
                            <MenuItem value="Friend">Friend</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Notes (Optional)"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              // pattern: "^[a-zA-Z0-9. ]+$",
                              maxLength: 500,
                            }}
                            value={values.notes}
                            onChange={handleChange("notes")}
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            mt={2}
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} lg={1.2}>
              <Link to={"/employees"}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                  Cancel
                </MDButton>
              </Link>
            </Grid>
            <Grid item xs={12} md={4} lg={1.2}>
              <MDButton
                onClick={nextTabs}
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
              >
                Next
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      )}
    </>
  );

  const employeeInfo = (
    <>
      {showEmployeeInfo && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDBox mt={6} p={4}>
                <Grid container spacing={3}>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Employee Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Employee Type"
                        onChange={handleChange("employeeType")}
                        value={values.employeeType}
                      >
                        <MenuItem value="">Select.. </MenuItem>
                        <MenuItem value="Fixed Rate">Fixed Rate</MenuItem>
                        <MenuItem value="Fixed Hour Rate">
                          Fixed Hour Rate
                        </MenuItem>
                        <MenuItem value="Part Time">Part Time</MenuItem>
                        <MenuItem value="Casual">Casual</MenuItem>
                      </Select>
                    </FormControl>
                    {employeeTypeErr ? (
                      <span style={errMsg}>Employee Type can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <TextField
                        type="text"
                        label="Employee Code"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          pattern: "^[A-Z0-9]+$",
                          maxLength: 15,
                        }}
                        onChange={handleChange("employeeCode")}
                        value={values.employeeCode}
                      />
                      {employeeCodeErr ? (
                        <span style={errMsg}>Employee Code can't be blank</span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <PickDate
                        selected={selectedDateJoin}
                        onChange={handleDateChangeJoin}
                        label="Joining Date"
                        maxDate={new Date()}
                      />
                    </MDBox>
                    {joiningDateErr ? (
                      <span style={errMsg}>Joining Date can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <PickDate
                        selected={selectedDateReleiving}
                        onChange={handleDateChangeReleiving}
                        label="Releiving Date"
                        minDate={new Date(values.joiningDate)}
                      />
                      {relievingDateErr ? (
                        <span style={errMsg}>
                          Relieving Date can't be blank
                        </span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Department
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Department"
                        onChange={handleChange("department")}
                        value={values.department}
                      >
                        {department}
                      </Select>
                    </FormControl>
                    {departmentErr ? (
                      <span style={errMsg}>Department can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Designation
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Designation"
                        onChange={handleChange("designation")}
                        value={values.designation}
                      >
                        {designation}
                      </Select>
                    </FormControl>
                    {designationErr ? (
                      <span style={errMsg}>Designation can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Circle
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Circle"
                        onChange={handleChange("circle")}
                        value={values.circle}
                      >
                        <MenuItem value="">Select.. </MenuItem>
                        <MenuItem value="South">South</MenuItem>
                        <MenuItem value="North">North</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <TextField
                      type="text"
                      label="Location"
                      variant="outlined"
                      fullWidth
                      inputProps={{
                        pattern: "^[A-Za-z0-9 ]+$",
                        maxLength: 50,
                      }}
                      onChange={handleChange("location")}
                      value={values.location}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <PickDate
                      selected={selectedDateJoinIssueDate}
                      onChange={handleDateChangeIssueDate}
                      label="ID Card Issue Date"
                      minDate={new Date(values.joiningDate)}
                      maxDate={new Date()}
                    />
                    {idCardIssueDateErr ? (
                      <span style={errMsg}>
                        ID Card Issue Date can't be blank
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3} sx={{ display: "flex" }}>
                    <TextField
                      type="file"
                      accept="image/*"
                      label="ID Card Picture"
                      InputLabelProps={{ shrink: true }}
                      variant="outlined"
                      fullWidth
                      onChange={saveFileIdCard}
                    />
                    <Grid item xs={2.5}>
                      {hideEyeId ? (
                        <IconButton
                          style={{ marginLeft: "14px", marginTop: "-3px" }}
                        >
                          <Visibility
                            fontSize="large"
                            color="info"
                            onClick={viewFileIdCard}
                          />
                        </IconButton>
                      ) : (
                        <IconButton
                          style={{ marginLeft: "14px", marginTop: "-3px" }}
                        >
                          <Visibility fontSize="large" color="grey" />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Attendence Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Attendence Type"
                        onChange={handleChange("attendanceType")}
                        value={values.attendanceType}
                      >
                        <MenuItem value="">Select.. </MenuItem>
                        <MenuItem value="Full Time">Full Time</MenuItem>
                        <MenuItem value="Hourly">Hourly</MenuItem>
                      </Select>
                    </FormControl>
                    {attendanceErr ? (
                      <span style={errMsg}>Attendance Type can't be blank</span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Recruitment Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Recruitment Type"
                        onChange={handleChange("recruitmentType")}
                        value={values.recruitmentType}
                      >
                        <MenuItem value="">Select.. </MenuItem>
                        <MenuItem value="Fresh">Fresh</MenuItem>
                        <MenuItem value="Replacement">Replacement</MenuItem>
                        <MenuItem value="Transfer">Transfer</MenuItem>
                        <MenuItem value="NotApplicable">NotApplicable</MenuItem>
                      </Select>
                    </FormControl>
                    {recruitmentErr ? (
                      <span style={errMsg}>
                        Recruitment Type can't be blank
                      </span>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <TextField
                        type="text"
                        label="Experience (Years) "
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          pattern: "^[0-9 ]+$",
                          maxLength: 3,
                        }}
                        onChange={handleChange("experienceYears")}
                        value={values.experienceYears}
                      />
                      {experienceYearsErr ? (
                        <span style={errMsg}>
                          Experience (Years) can't be blank
                        </span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <TextField
                        type="text"
                        label="Experience (Months)"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          pattern: "^[0-9 ]+$",
                          maxLength: 2,
                        }}
                        onChange={handleChange("experienceMonths")}
                        value={values.experienceMonths}
                      />
                      {experienceMonthsErr ? (
                        <span style={errMsg}>{experienceMonthsTitleErr}</span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Reporting Manager Employee Name
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Reporting Manager Employee Name"
                        onChange={handleChange("reportingManagerEmployeeID")}
                        value={values.reportingManagerEmployeeID}
                      >
                        {EmployeeList}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <TextField
                        type="text"
                        label="Tax File Number"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          pattern: "^[A-Za-z0-9 ]+$",
                          maxLength: 15,
                        }}
                        value={values.taxFileNumber}
                        onChange={handleChange("taxFileNumber")}
                      />
                      {taxFileNumberErr ? (
                        <span style={errMsg}>
                          Tax File Number can't be blank
                        </span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>{" "}
                  <Grid item xs={12} lg={6}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Super Guarantee Fund Product
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Super Guarantee Fund Product"
                        onChange={handleChange("superGuaranteeFundProduct")}
                        value={values.superGuaranteeFundProduct}
                      >
                        <MenuItem value="AmgSuper">AMG Super </MenuItem>
                        <MenuItem value="AustralianSuper">
                          Australian Super
                        </MenuItem>
                        <MenuItem value="Transfer">Transfer</MenuItem>
                        <MenuItem value="NotApplicable">
                          Not Applicable
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <TextField
                        type="text"
                        label="Member Number"
                        variant="outlined"
                        fullWidth
                        inputProps={{
                          pattern: "^[A-Za-z0-9 ]+$",
                          maxLength: 15,
                        }}
                        value={values.memberNumber}
                        onChange={handleChange("memberNumber")}
                      />
                      {memberNumberErr ? (
                        <span style={errMsg}>Member Number can't be blank</span>
                      ) : (
                        ""
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Mobile App/Web Access
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ height: "44.13px" }}
                        label="Mobile App/Web Access"
                        onChange={handleChange("mobileAppAccess")}
                        value={values.mobileAppAccess}
                      >
                        <MenuItem value="None">None</MenuItem>
                        <MenuItem value="Driver">Driver</MenuItem>
                        <MenuItem value="Warehouse">Warehouse</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {showfield && (
                    <>
                      {values.mobileAppAccess === "Warehouse" && (
                        <Grid item xs={12} lg={3}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Employee Warehouse Location
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              style={{ height: "44.13px" }}
                              label="Employee Warehouse Location"
                              value={values.employeeWarehouseLocation}
                              onChange={handleChange(
                                "employeeWarehouseLocation"
                              )}
                            >
                              {warehouse}
                            </Select>
                          </FormControl>
                          {employeeWarehouseLocationErr ? (
                            <span style={errMsg}>
                              Employee Warehouse Location can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </Grid>
                      )}
                      {values.mobileAppAccess === "Driver" && (
                        <>
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <TextField
                                type="text"
                                label="Mobile App User Name"
                                variant="outlined"
                                fullWidth
                                inputProps={{
                                  pattern: "^[A-Za-z0-9@.]+$",
                                  maxLength: 30,
                                }}
                                value={values.mobileAppUserName}
                                onChange={handleChange("mobileAppUserName")}
                              />
                              {mobileAppUserNameErr ? (
                                <span style={errMsg}>
                                  Mobile App User Name can't be blank
                                </span>
                              ) : (
                                ""
                              )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={3}>
                            <MDBox component="form" role="form">
                              <TextField
                                type="password"
                                label="Mobile App Password"
                                variant="outlined"
                                fullWidth
                                inputProps={{
                                  // pattern: "^[A-Za-z0-9@.]+$",
                                  maxLength: 30,
                                }}
                                value={values.mobileAppUserPassword}
                                onChange={handleChange("mobileAppUserPassword")}
                              />

                              {mobileAppUserPasswordErr ? (
                                <span style={errMsg}>
                                  Mobile App Password can't be blank
                                </span>
                              ) : (
                                ""
                              )}
                            </MDBox>
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                </Grid>
              </MDBox>
              <Grid
                container
                mt={2}
                columnSpacing={4}
                alignItems="center"
                display="flex"
                justifyContent="center"
                mb={4}
              >
                <Grid item xs={12} md={4} lg={1.2}>
                  <Link to={"/employees"}>
                    <MDButton
                      className="btn-block center-container-btn btn-warning btn-back rightSpace"
                      color="warning"
                      fullWidth
                    >
                      Cancel
                    </MDButton>
                  </Link>
                </Grid>
                <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                  <MDButton
                    onClick={disableColor ? blank : updateEmployee}
                    rel="noreferrer"
                    variant="contained"
                    className={
                      "btn-block center-container-btn btn-warning btn-back rightSpace"
                    }
                    color={disableColor ? "secondary" : "success"}
                    fullWidth
                  >
                    Save
                  </MDButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );

  const fetchDocument = async () => {
    values1.employeeID = id;
    getDocument(
      values1,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  const fetchDocumentView = async (_id) => {
    setShowViewImageModalFlag(true);
    values1.documentFileName = _id;
    if (_id !== undefined && _id !== "") {
      setViewImage(appConstants.baseURL + "employee/viewFile?fileName=" + _id);
    }
  };

  const handleCancelImage = (name) => (event) => {
    setShowViewImageModalFlag(false);
  };

  let columns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      sortField: "documentName",
    },
    {
      name: "Document Type",
      selector: (row) => row.documentType,
      sortable: true,
      sortField: "documentType",
    },
    {
      name: "Uploaded Date Time",
      selector: (row) => row.uploadedDateString,
      sortable: true,
      sortField: "uploadedDate",
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item style={{ marginLeft: "-20px" }}>
              <TimelineItem
                color="info"
                icon="visibility"
                title="View"
                onClick={() =>
                  fetchDocumentView(row.idAndPath.documentFileName)
                }
              />
            </Grid>
            <Grid item>
              <Link
                to={`/employees/editDocument/${row.idAndPath._id}?emp=${values.id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row.idAndPath._id)}
                title="Delete"
              />
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchDocument();
  }, [values1.page, values1.limit, values1.sortingType]);
  const documents = (
    <>
      {showDocuments && (
        <>
          <Grid
            container
            display={"flex"}
            justifyContent="end"
            mt={3}
            pt={3}
            pb={3}
            gap={2}
            px={2.2}
          >
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values1.filterValues}
                onChange={(e) =>
                  setValues1({ ...values1, filterValues: e.target.value })
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.5rem  0.5rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={fetchDocument}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: "16px" }}>
              <Link to={`/employees/addDocument/${empID}`}>
                <MDButton
                  variant="contained"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color={disableColor ? "secondary" : "success"}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows
              // onSort={handleSort}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              contextActions={contextActions}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleCleared}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}
            />
          </CardContent>
        </>
      )}
    </>
  );

  const handleDeleteDialogeClick = async (_id) => {
    values._id = [];
    values._id.push(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteDocument();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteDocument = async () => {
    sessionStorage.setItem("PARA_TABLE", "documents");
    deleteSelectedDocument(
      values,
      (data) => {
        if (data.Result_Status) fetchDocument();
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  const renderTable = () => {
    return (
      <>
        {personalInfo}
        {employeeInfo}
        {documents}
      </>
    );
  };
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container>
          <Grid item xs={12} md={6} lg={6} px={2} mb={-3.5}>
            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                indicatorColor={"primary"}
                sx={{
                  "& .Mui-selected": {
                    color: "#fff !important",
                    background: `${barColor} !important`,
                  },
                  ".MuiTabs-indicator": {
                    background: `${barColor} !important`,
                  },
                }}
              >
                <Tab
                  onClick={() => setTable("personalInformation")}
                  label="Personal Information"
                />
                <Tab
                  disabled={empID === "" ? true : false}
                  onClick={() => setTable("employeeInformation")}
                  label="Employee Information"
                />
                <Tab
                  disabled={empID === "" ? true : false}
                  onClick={() => setTable("documents")}
                  label="Documents"
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>

        {renderTable()}
      </Card>

      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />

      <ShowProfile
        open={showViewImageFlag}
        fileName={viewImage}
        closeModalClick={handleCancelImage("closeModalClick")}
      />

      <ShowProfile
        open={showProfileModalFlag}
        fileName={file}
        closeModalClick={handleCancelProfilePic("closeModalClick")}
      />

      <ShowProfile
        open={showProfileModalFlagIdcard}
        fileName={fileIdCard}
        closeModalClick={handleCancelIdCard("closeModalClick")}
      />

      {/* <LoadingModal loading={loading} /> */}
    </DashboardLayout>
  );
}

export default EditEmployee;
